import {
	SearchFilter,
	SearchFilterOptionText,
	SearchFilterOptionTextActive,
} from "../../../redux-magic/sub-interfaces/search-types";

export const _h_bedrooms_variant_2: SearchFilter = {
	id: "bedrooms_variant_2",
	title: "Bedrooms",
	level: 3,
	index: 7,
	presentation_type: "checkboxes",
	multi: true,
	affects: [],
	affected_by: ["property_type"],
	priority: 3,
	is_advanced: false,
	included_in_search_bar: true,
	option_type: "text",
	possible_options: [
		{
			id: "1_bhk",
			title: "1 BHK",
			value: "1",
		},
		{
			id: "2_bhk",
			title: "2 BHK",
			value: "2",
		},
		{
			id: "3_bhk",
			title: "3 BHK",
			value: "3",
		},
		{
			id: "4_bhk",
			title: "4 BHK",
			value: "4",
		},
		{
			id: "5_bhk",
			title: "5 BHK",
			value: "5",
		},
		{
			id: "6_bhk",
			title: "6 BHK",
			value: "6",
		},
		{
			id: "6_plus_bhk",
			title: "6+ BHK",
			value: "7",
		},
	] as Array<SearchFilterOptionText>,
	active_options: [
		{
			id: "1_bhk",
			title: "1 BHK",
			value: "1",
			is_selected: false,
		},
		{
			id: "2_bhk",
			title: "2 BHK",
			value: "2",
			is_selected: false,
		},
		{
			id: "3_bhk",
			title: "3 BHK",
			value: "3",
			is_selected: false,
		},
		{
			id: "4_bhk",
			title: "4 BHK",
			value: "4",
			is_selected: false,
		},
		{
			id: "5_bhk",
			title: "5 BHK",
			value: "5",
			is_selected: false,
		},
		{
			id: "6_bhk",
			title: "6 BHK",
			value: "6",
			is_selected: false,
		},
		{
			id: "6_plus_bhk",
			title: "6+ BHK",
			value: "7",
			is_selected: false,
		},
	] as Array<SearchFilterOptionTextActive>,
	selected_options: [] as Array<SearchFilterOptionText>,
	db_collection: "properties",
	db_field: "bhk",
	is_visible: true,
	is_applied: false,
	is_accordion_open: true,
};
